import React from "react";
import serviceNowImg1 from "../../../assets/releasenote4.png";
import serviceNowImg2 from "../../../assets/releasenote41.png";
import dashboardImg from "../../../assets/releasenote42.png";
import emailTemplateImg from "../../../assets/releasenote43.png";
import exceptionAnalysisImg from "../../../assets/releasenote44.png";

export function renderNetraaAPMReleaseNotes4() {
  return <RenderNetraaAPMReleaseNotes />;
}

function RenderNetraaAPMReleaseNotes() {
  const [zoomImage, setZoomImage] = React.useState(null);

  const releaseMetrics = [
    { label: "Modules Updated", value: "09" },
    { label: "Key Areas", value: "09" },
    { label: "Security & Governance", value: "0" },
    { label: "Impact Score", value: "9.2" },
  ];

  const releasePills = [
    "ServiceNow Integration",
    ".NET Agent Enhancements",
    "Enhanced MSSQL Monitoring",
    "Exception Analysis Module",
  ];

  const mssqlMetrics = [
    { name: "meter_mssql_qps", desc: "The average rate of queries being executed by the SQL Server.", unit: "Count / Second" },
    { name: "meter_mssql_slow_queries_rate", desc: "Rate of slow queries.", unit: "Queries/s" },
    { name: "meter_mssql_commands_select_rate", desc: "Rate of SELECT commands.", unit: "Commands/s" },
    { name: "meter_mssql_commands_insert_rate", desc: "Rate of INSERT commands.", unit: "Commands/s" },
    { name: "meter_mssql_commands_update_rate", desc: "Rate of UPDATE commands.", unit: "Commands/s" },
    { name: "meter_mssql_commands_delete_rate", desc: "Rate of DELETE commands.", unit: "Commands/s" },
    { name: "meter_mssql_connects_available", desc: "The maximum number of concurrent threads/users connected to the SQL Server during the selected time window.", unit: "Count" },
    { name: "meter_mssql_connects_aborted", desc: "Number of aborted connections.", unit: "Count" },
    { name: "meter_mssql_threads_running", desc: "Number of running threads.", unit: "Count" },
    { name: "meter_mssql_threads_created", desc: "Number of created threads.", unit: "Count" },
    { name: "meter_mssql_threads_connected", desc: "Number of connected threads.", unit: "Count" },
    { name: "meter_mssql_connection_errors_internal", desc: "Number of internal connection errors.", unit: "Count" },
    { name: "meter_mssql_connection_errors_max_connections", desc: "Number of max connection errors.", unit: "Count" },
    { name: "meter_mssql_slow_statements", desc: "Number of slow statements.", unit: "Count" },
    { name: "meter_mssql_sp_errors", desc: "Number of stored procedure errors.", unit: "Count" },
    { name: "meter_mssql_deadlock_details", desc: "Details of deadlocks.", unit: "Info" },
    { name: "meter_mssql_databases_state", desc: "The current operational status of the database (e.g., Online, Restoring, Recovering, Suspect, Offline).", unit: "State Code (Integer)" },
    { name: "meter_mssql_databases_transactions", desc: "Number of database transactions.", unit: "Count" },
    { name: "meter_mssql_host_cpus", desc: "Number of host CPUs.", unit: "Count" },
    { name: "meter_mssql_cpu_kernelTime", desc: "The amount of CPU processing power currently being consumed by the SQL Server instance.", unit: "Percentage (%)" },
    { name: "meter_mssql_cpu_userTime", desc: "The amount of CPU processing power currently being consumed by the SQL Server instance.", unit: "Percentage (%)" },
    { name: "meter_mssql_memory_physical", desc: "The total physical memory in use by the underlying operating system.", unit: "Kilobytes (KB)" },
    { name: "meter_mssql_memory_virtual", desc: "Virtual memory usage.", unit: "Bytes" },
    { name: "meter_mssql_memory_total", desc: "The actual amount of memory that SQL Server has committed and is currently using from the operating system.", unit: "Kilobytes (KB)" },
    { name: "meter_mssql_memory_target", desc: "Target memory.", unit: "Bytes" },
    { name: "meter_mssql_uptime", desc: "Uptime of the server.", unit: "Seconds" },
    { name: "meter_mssql_general_logins", desc: "Number of general logins.", unit: "Count" },
    { name: "meter_mssql_general_userConnections", desc: "The total number of active user connections currently established with the SQL Server.", unit: "Count" },
    { name: "meter_mssql_general_processesBlocked", desc: "Number of blocked processes.", unit: "Count" },
    { name: "meter_mssql_worker_activeWorkers", desc: "Number of active workers.", unit: "Count" },
    { name: "meter_mssql_worker_maxWorkers", desc: "Maximum number of workers.", unit: "Count" },
    { name: "meter_mssql_worker_threadsPercent", desc: "The count of active, idle, or suspended worker threads processing SQL tasks.", unit: "Count" },
    { name: "meter_mssql_replica_bytesSent", desc: "Bytes sent by replica.", unit: "—" },
    { name: "meter_mssql_replica_sends", desc: "Sends by replica.", unit: "—" },
    { name: "meter_mssql_replica_bytesSentToTransport", desc: "Bytes sent to transport by replica.", unit: "—" },
    { name: "meter_mssql_replica_sendsToTransport", desc: "Sends to transport by replica.", unit: "—" },
    { name: "meter_mssql_replica_bytesReceived", desc: "Bytes received by replica.", unit: "Bytes" },
    { name: "meter_mssql_replica_receives", desc: "Receives by replica.", unit: "Count" },
    { name: "meter_mssql_replica_resentMessages", desc: "Resent messages by replica.", unit: "Count" },
    { name: "meter_mssql_sql_agent_status", desc: "Indicates whether the SQL Server Agent service (used for running scheduled jobs) is active.", unit: "Status Code (Integer - 1 = Running, 0 = Stopped)" },
    { name: "meter_mssql_always_on_db_synchronizationState", desc: "Always On DB synchronization state.", unit: "State" },
    { name: "meter_mssql_always_on_db_synchronizationHealth", desc: "Always On DB synchronization health.", unit: "Health" },
    { name: "meter_mssql_always_on_db_state", desc: "Always On DB state.", unit: "State" },
    { name: "meter_mssql_always_on_db_logSendQueueSize", desc: "Always On DB log send queue size.", unit: "Bytes" },
    { name: "meter_mssql_always_on_db_logSendRate", desc: "Always On DB log send rate.", unit: "Bytes/s" },
    { name: "meter_mssql_always_on_db_redoQueueSize", desc: "Always On DB redo queue size.", unit: "—" },
    { name: "meter_mssql_always_on_db_redoRate", desc: "Always On DB redo rate.", unit: "Bytes/s" },
    { name: "meter_mssql_always_on_db_filestreamSendRate", desc: "Always On DB filestream send rate.", unit: "Bytes/s" },
    { name: "meter_mssql_always_on_ag_automatedBackupPreference", desc: "Always On AG automated backup preference.", unit: "Preference" },
    { name: "meter_mssql_always_on_ag_primaryRecoveryHealth", desc: "Always On AG primary recovery health.", unit: "Health" },
    { name: "meter_mssql_always_on_ag_secondaryRecoveryHealth", desc: "Always On AG secondary recovery health.", unit: "Health" },
    { name: "meter_mssql_always_on_ag_synchronizationHealth", desc: "Always On AG synchronization health.", unit: "Health" },
    { name: "meter_mssql_always_on_ar_availabilityMode", desc: "Always On AR availability mode.", unit: "Mode" },
    { name: "meter_mssql_always_on_ar_failoverMode", desc: "Always On AR failover mode.", unit: "Mode" },
    { name: "meter_mssql_always_on_ar_isLocal", desc: "Always On AR is local.", unit: "Boolean" },
    { name: "meter_mssql_always_on_ar_role", desc: "Always On AR role.", unit: "Role" },
    { name: "meter_mssql_always_on_ar_operationalState", desc: "Always On AR operational state.", unit: "State" },
    { name: "meter_mssql_always_on_ar_recoveryHealth", desc: "Always On AR recovery health.", unit: "Health" },
    { name: "meter_mssql_always_on_ar_synchronizationHealth", desc: "Always On AR synchronization health.", unit: "Health" },
    { name: "meter_mssql_always_on_ar_connectedState", desc: "Always On AR connected state.", unit: "State" },
    { name: "meter_mssql_buffers_cacheHitRatio", desc: "The percentage of data pages found directly in the memory buffer cache without needing to read from the physical disk. A healthy server usually has this > 90%.", unit: "Percentage (%)" },
    { name: "meter_mssql_buffers_freeListStalls", desc: "Buffer free list stalls.", unit: "Count" },
    { name: "meter_mssql_buffers_pageReads", desc: "Buffer page reads.", unit: "—" },
    { name: "meter_mssql_buffers_pageWrites", desc: "Buffer page writes.", unit: "Count" },
    { name: "meter_mssql_buffers_checkpointPages", desc: "Buffer checkpoint pages.", unit: "Count" },
    { name: "meter_mssql_buffers_pageLifeExpectancy", desc: "The average number of seconds a data page stays in the buffer pool before being flushed out. Higher is better (traditionally > 300s).", unit: "Seconds" },
    { name: "meter_mssql_memory_connection", desc: "Memory connection.", unit: "Bytes" },
    { name: "meter_mssql_memory_grantsOutstanding", desc: "Memory grants outstanding.", unit: "—" },
    { name: "meter_mssql_memory_grantsPending", desc: "The total number of queries currently waiting for a workspace memory grant to begin execution. Ideally, this should be 0.", unit: "Count" },
    { name: "meter_mssql_sessions", desc: "Number of sessions.", unit: "Count" },
    { name: "meter_mssql_databases_file_size", desc: "Database file size.", unit: "—" },
    { name: "meter_mssql_databases_file_usedSpace", desc: "Database file used space.", unit: "Bytes" },
    { name: "meter_mssql_databases_file_emptySpace", desc: "Database file empty space.", unit: "—" },
    { name: "meter_mssql_databases_failedDistributedTransactions", desc: "Failed distributed transactions.", unit: "Count" },
    { name: "meter_mssql_locks_byWaitType", desc: "Locks by wait type.", unit: "Count" },
    { name: "meter_mssql_sql_batchRequests", desc: "SQL batch requests.", unit: "Count" },
    { name: "meter_mssql_sql_compilations", desc: "SQL compilations.", unit: "Count" },
    { name: "meter_mssql_sql_recompilations", desc: "SQL recompilations.", unit: "Count" },
    { name: "meter_mssql_locks_elapsedTimeRequestsPercent", desc: "Locks elapsed time requests percent.", unit: "—" },
    { name: "meter_mssql_locks_timeouts", desc: "Locks timeouts.", unit: "—" },
    { name: "meter_mssql_locks_deadlocks", desc: "Locks deadlocks.", unit: "Count" },
    { name: "meter_mssql_locks_waits", desc: "Locks waits.", unit: "Count" },
    { name: "meter_mssql_locks_waitTime", desc: "Locks wait time.", unit: "—" },
    { name: "meter_mssql_latches_waits", desc: "Latches waits.", unit: "—" },
    { name: "meter_mssql_latches_averageWaitTime", desc: "Latches average wait time.", unit: "—" },
    { name: "meter_mssql_databases_log_filesSize", desc: "Database log files size.", unit: "Bytes" },
    { name: "meter_mssql_databases_log_filesUsedSize", desc: "Database log files used size.", unit: "Bytes" },
    { name: "meter_mssql_databases_log_flushWaits", desc: "Database log flush waits.", unit: "Count" },
    { name: "meter_mssql_databases_log_growths", desc: "Database log growths.", unit: "Count" },
    { name: "meter_mssql_databases_log_shrinks", desc: "Database log shrinks.", unit: "Count" },
    { name: "meter_mssql_databases_log_truncations", desc: "Database log truncations.", unit: "Count" },
    { name: "meter_mssql_databases_log_percentUsed", desc: "Database log percent used.", unit: "%" },
    { name: "meter_mssql_databases_backup_age", desc: "Database backup age.", unit: "Seconds" },
    { name: "meter_mssql_databases_backup_size", desc: "Database backup size.", unit: "Bytes" },
    { name: "meter_mssql_instance_uptime", desc: "Instance uptime.", unit: "Seconds" },
    { name: "meter_mssql_instance_max_connections", desc: "Instance max connections.", unit: "Count" },
    { name: "meter_mssql_instance_buffer_pool_size", desc: "Instance buffer pool size.", unit: "Bytes" },
    { name: "meter_mssql_instance_worker_threads_size", desc: "Instance worker threads size.", unit: "Count" },
    { name: "meter_mssql_instance_qps", desc: "Instance queries per second.", unit: "QPS" },
    { name: "meter_mssql_instance_slow_queries_rate", desc: "Instance slow queries rate.", unit: "Queries/s" },
    { name: "meter_mssql_instance_commands_select_rate", desc: "Instance SELECT commands rate.", unit: "Commands/s" },
    { name: "meter_mssql_instance_commands_insert_rate", desc: "Instance INSERT commands rate.", unit: "Commands/s" },
    { name: "meter_mssql_instance_commands_update_rate", desc: "Instance UPDATE commands rate.", unit: "Commands/s" },
    { name: "meter_mssql_instance_commands_delete_rate", desc: "Instance DELETE commands rate.", unit: "Commands/s" },
    { name: "meter_mssql_instance_connects_available", desc: "Instance connects available.", unit: "Count" },
    { name: "meter_mssql_instance_connects_aborted", desc: "Instance connects aborted.", unit: "Count" },
    { name: "meter_mssql_instance_threads_running", desc: "Instance threads running.", unit: "Count" },
    { name: "meter_mssql_instance_threads_created", desc: "Instance threads created.", unit: "Count" },
    { name: "meter_mssql_instance_threads_connected", desc: "Instance threads connected.", unit: "Count" },
    { name: "meter_mssql_instance_connection_errors_internal", desc: "Instance connection errors internal.", unit: "Count" },
    { name: "meter_mssql_instance_connection_errors_max_connections", desc: "Instance connection errors max connections.", unit: "Count" },
    { name: "meter_mssql_instance_slow_statements", desc: "Instance slow statements.", unit: "Count" },
    { name: "meter_mssql_instance_sp_errors", desc: "Instance SP errors.", unit: "Count" },
    { name: "meter_mssql_instance_deadlock_details", desc: "Instance deadlock details.", unit: "Info" },
    { name: "meter_mssql_instance_databases_state", desc: "Instance databases state.", unit: "State" },
    { name: "meter_mssql_instance_databases_transactions", desc: "Instance databases transactions.", unit: "Count" },
    { name: "meter_mssql_instance_host_cpus", desc: "Instance host CPUs.", unit: "Count" },
    { name: "meter_mssql_instance_cpu_kernelTime", desc: "Instance CPU kernel time.", unit: "ms" },
    { name: "meter_mssql_instance_cpu_userTime", desc: "Instance CPU user time.", unit: "ms" },
    { name: "meter_mssql_instance_memory_physical", desc: "Instance memory physical.", unit: "Bytes" },
    { name: "meter_mssql_instance_memory_virtual", desc: "Instance memory virtual.", unit: "Bytes" },
    { name: "meter_mssql_instance_memory_total", desc: "Instance memory total.", unit: "Bytes" },
    { name: "meter_mssql_instance_memory_target", desc: "Instance memory target.", unit: "Bytes" },
    { name: "meter_mssql_instance_general_logins", desc: "Instance general logins.", unit: "Count" },
    { name: "meter_mssql_instance_general_userConnections", desc: "Instance general user connections.", unit: "Count" },
    { name: "meter_mssql_instance_general_processesBlocked", desc: "Instance general processes blocked.", unit: "Count" },
    { name: "meter_mssql_instance_worker_activeWorkers", desc: "Instance worker active workers.", unit: "Count" },
    { name: "meter_mssql_instance_worker_maxWorkers", desc: "Instance worker max workers.", unit: "Count" },
    { name: "meter_mssql_instance_worker_threadsPercent", desc: "Instance worker threads percent.", unit: "%" },
    { name: "meter_mssql_instance_replica_bytesSent", desc: "Instance replica bytes sent.", unit: "Bytes" },
    { name: "meter_mssql_instance_replica_sends", desc: "Instance replica sends.", unit: "Count" },
    { name: "meter_mssql_instance_replica_bytesSentToTransport", desc: "Instance replica bytes sent to transport.", unit: "Bytes" },
    { name: "meter_mssql_instance_replica_sendsToTransport", desc: "Instance replica sends to transport.", unit: "Count" },
    { name: "meter_mssql_instance_replica_bytesReceived", desc: "Instance replica bytes received.", unit: "Bytes" },
    { name: "meter_mssql_instance_replica_receives", desc: "Instance replica receives.", unit: "Count" },
    { name: "meter_mssql_instance_replica_resentMessages", desc: "Instance replica resent messages.", unit: "Count" },
    { name: "meter_mssql_instance_sql_agent_status", desc: "Instance SQL agent status.", unit: "Status" },
    { name: "meter_mssql_instance_always_on_db_synchronizationState", desc: "Instance always on db synchronization state.", unit: "State" },
    { name: "meter_mssql_instance_always_on_db_synchronizationHealth", desc: "Instance always on db synchronization health.", unit: "Health" },
    { name: "meter_mssql_instance_always_on_db_state", desc: "Instance always on db state.", unit: "State" },
    { name: "meter_mssql_instance_always_on_db_logSendQueueSize", desc: "Instance always on db log send queue size.", unit: "Bytes" },
    { name: "meter_mssql_instance_always_on_db_logSendRate", desc: "Instance always on db log send rate.", unit: "Bytes/s" },
    { name: "meter_mssql_instance_always_on_db_redoQueueSize", desc: "Instance always on db redo queue size.", unit: "Bytes" },
    { name: "meter_mssql_instance_always_on_db_redoRate", desc: "Instance always on db redo rate.", unit: "Bytes/s" },
    { name: "meter_mssql_instance_always_on_db_filestreamSendRate", desc: "Instance always on db filestream send rate.", unit: "Bytes/s" },
    { name: "meter_mssql_instance_always_on_ag_automatedBackupPreference", desc: "Instance always on ag automated backup preference.", unit: "Preference" },
    { name: "meter_mssql_instance_always_on_ag_primaryRecoveryHealth", desc: "Instance always on ag primary recovery health.", unit: "Health" },
    { name: "meter_mssql_instance_always_on_ag_secondaryRecoveryHealth", desc: "Instance always on ag secondary recovery health.", unit: "Health" },
    { name: "meter_mssql_instance_always_on_ag_synchronizationHealth", desc: "Instance always on ag synchronization health.", unit: "Health" },
    { name: "meter_mssql_instance_always_on_ar_availabilityMode", desc: "Instance always on ar availability mode.", unit: "Mode" },
    { name: "meter_mssql_instance_always_on_ar_failoverMode", desc: "Instance always on ar failover mode.", unit: "Mode" },
    { name: "meter_mssql_instance_always_on_ar_isLocal", desc: "Instance always on ar is local.", unit: "Boolean" },
    { name: "meter_mssql_instance_always_on_ar_role", desc: "Instance always on ar role.", unit: "Role" },
    { name: "meter_mssql_instance_always_on_ar_operationalState", desc: "Instance always on ar operational state.", unit: "State" },
    { name: "meter_mssql_instance_always_on_ar_recoveryHealth", desc: "Instance always on ar recovery health.", unit: "Health" },
    { name: "meter_mssql_instance_always_on_ar_synchronizationHealth", desc: "Instance always on ar synchronization health.", unit: "Health" },
    { name: "meter_mssql_instance_always_on_ar_connectedState", desc: "Instance always on ar connected state.", unit: "State" },
    { name: "meter_mssql_instance_buffers_cacheHitRatio", desc: "Instance buffers cache hit ratio.", unit: "%" },
    { name: "meter_mssql_instance_buffers_freeListStalls", desc: "Instance buffers free list stalls.", unit: "Count" },
    { name: "meter_mssql_instance_buffers_pageReads", desc: "Instance buffers page reads.", unit: "Count" },
    { name: "meter_mssql_instance_buffers_pageWrites", desc: "Instance buffers page writes.", unit: "Count" },
    { name: "meter_mssql_instance_buffers_checkpointPages", desc: "Instance buffers checkpoint pages.", unit: "Count" },
    { name: "meter_mssql_instance_buffers_pageLifeExpectancy", desc: "Instance buffers page life expectancy.", unit: "Seconds" },
    { name: "meter_mssql_instance_memory_connection", desc: "Instance memory connection.", unit: "Bytes" },
    { name: "meter_mssql_instance_memory_grantsOutstanding", desc: "Instance memory grants outstanding.", unit: "Count" },
    { name: "meter_mssql_instance_memory_grantsPending", desc: "Instance memory grants pending.", unit: "Count" },
    { name: "meter_mssql_instance_sessions", desc: "Instance sessions.", unit: "Count" },
    { name: "meter_mssql_instance_databases_file_size", desc: "Instance databases file size.", unit: "Bytes" },
    { name: "meter_mssql_instance_databases_file_usedSpace", desc: "Instance databases file used space.", unit: "Bytes" },
    { name: "meter_mssql_instance_databases_file_emptySpace", desc: "Instance databases file empty space.", unit: "Bytes" },
    { name: "meter_mssql_instance_databases_failedDistributedTransactions", desc: "Instance databases failed distributed transactions.", unit: "Count" },
    { name: "meter_mssql_instance_locks_byWaitType", desc: "Instance locks by wait type.", unit: "Count" },
    { name: "meter_mssql_instance_sql_batchRequests", desc: "Instance SQL batch requests.", unit: "Count" },
    { name: "meter_mssql_instance_sql_compilations", desc: "Instance SQL compilations.", unit: "Count" },
    { name: "meter_mssql_instance_sql_recompilations", desc: "Instance SQL recompilations.", unit: "Count" },
    { name: "meter_mssql_instance_locks_elapsedTimeRequestsPercent", desc: "Instance locks elapsed time requests percent.", unit: "%" },
    { name: "meter_mssql_instance_locks_timeouts", desc: "Instance locks timeouts.", unit: "Count" },
    { name: "meter_mssql_instance_locks_deadlocks", desc: "Instance locks deadlocks.", unit: "Count" },
    { name: "meter_mssql_instance_locks_waits", desc: "Instance locks waits.", unit: "Count" },
    { name: "meter_mssql_instance_locks_waitTime", desc: "Instance locks wait time.", unit: "ms" },
    { name: "meter_mssql_instance_latches_waits", desc: "Instance latches waits.", unit: "Count" },
    { name: "meter_mssql_instance_latches_averageWaitTime", desc: "Instance latches average wait time.", unit: "ms" },
    { name: "meter_mssql_instance_databases_log_filesSize", desc: "Instance databases log files size.", unit: "Bytes" },
    { name: "meter_mssql_instance_databases_log_filesUsedSize", desc: "Instance databases log files used size.", unit: "Bytes" },
    { name: "meter_mssql_instance_databases_log_flushWaits", desc: "Instance databases log flush waits.", unit: "Count" },
    { name: "meter_mssql_instance_databases_log_growths", desc: "Instance databases log growths.", unit: "Count" },
    { name: "meter_mssql_instance_databases_log_shrinks", desc: "Instance databases log shrinks.", unit: "Count" },
    { name: "meter_mssql_instance_databases_log_truncations", desc: "Instance databases log truncations.", unit: "Count" },
    { name: "meter_mssql_instance_databases_log_percentUsed", desc: "Instance databases log percent used.", unit: "%" },
    { name: "meter_mssql_instance_databases_backup_age", desc: "Instance databases backup age.", unit: "Seconds" },
    { name: "meter_mssql_instance_databases_backup_size", desc: "Instance databases backup size.", unit: "Bytes" },
  ];

  const majorFeatureEnhancements = [
    {
      number: 1,
      title: "ServiceNow Integration",
      subsections: [
        {
          title: "Automated Ticket Creation",
          items: [
            "Developed Netraa APM's ServiceNow integration to make it easier to connect monitoring alerts with ServiceNow.",
            "Alerts from Netraa APM can now automatically create the required ServiceNow tickets as soon as an issue is detected, removing the need for manual ticket logging.",
          ],
        },
      ],
    },
    {
      number: 2,
      title: ".NET Agent Enhancements",
      subsections: [
        {
          title: ".NET 4.5 Agent",
          items: [
            "Introduced a dedicated .NET 4.5 Agent to support framework-based applications running on this version.",
          ],
        },
        {
          title: "Dynamic Class Handling",
          items: [
            "Updated the .NET Agent to correctly handle UI-generated dynamic classes, improving instrumentation accuracy for applications that generate classes at runtime.",
          ],
        },
        {
          title: ".NET Core Agent",
          items: [
            "Added functionality to skip resource calls in the .NET Core Agent, reducing noise and improving the relevance of captured transaction data.",
          ],
        },
      ],
    },
    {
      number: 3,
      title: "Dashboard & Visualization Enhancements",
      subsections: [
        {
          title: "New Visualization Types",
          items: [
            "Added configuration support for Meter Gauge, Donut, Table View, and Progress Bar visualizations.",
          ],
        },
        {
          title: "Metric Display Configuration",
          items: [
            "Added Metric Title Configuration to customize metric titles.",
            "Added Chart Background Color configuration.",
            "Added Icon Configuration for metrics, along with an Icon Enable/Disable option to control icon visibility.",
            "All of these configurations can be applied individually to each metric, based on the requirements of each dashboard.",
          ],
        },
      ],
    },
    {
      number: 4,
      title: "Java Agent – Exception Tracking",
      subsections: [
        {
          title: "Stack Trace Tagging",
          items: [
            "Exception class names from stack traces are now collected as searchable tags, enabling users to quickly find traces containing specific exceptions.",
          ],
        },
      ],
    },
    {
      number: 5,
      title: "Licensing Module (ApMoSys Licensing Portal)",
      subsections: [
        {
          title: "ApMoSys Licensing Portal (ALP)",
          items: [
            "Netraa APM now supports licensing through the ApMoSys Licensing Portal (ALP).",
            "Backward compatibility has been maintained for clients still using the legacy licensing module, ensuring a smooth transition.",
          ],
        },
      ],
    },
    {
      number: 6,
      title: "Enhanced MSSQL Monitoring",
      subsections: [
        {
          title: "Monitoring Enhancements",
          items: [
            "Added new MSSQL metrics for deeper visibility into database performance.",
            "Added dedicated dashboard visualizations for MSSQL metrics.",
            "Added alert configuration support so teams can be notified proactively of MSSQL-related issues.",
          ],
        },
      ],
    },
    {
      number: 7,
      title: "JPQL Migration",
      subsections: [
        {
          title: "Repository Migration",
          items: [
            "Migrated Alert, Mail, and Metric Configuration repositories from native SQL to JPQL.",
            "This improves Oracle compatibility and overall database portability across supported database platforms.",
          ],
        },
      ],
    },
    {
      number: 8,
      title: "Configurable Alert Email Templates",
      subsections: [
        {
          title: "Template Customization",
          items: [
            "Added customizable email subjects and bodies.",
            "Added support for dynamic placeholders within templates.",
            "Introduced unique Problem IDs for each alert notification.",
            "Added support for both HTML and plain-text formats.",
            "Added template validation and an email preview capability before alerts are sent.",
          ],
        },
      ],
    },
    {
      number: 9,
      title: "Exception Analysis Module",
      subsections: [
        {
          title: "Exception Aggregation & Analysis",
          items: [
            "Introduced backend APIs and an Angular UI for exception aggregation and trend analysis.",
            "Added application filtering and summary tables for a consolidated view of exceptions.",
            "Enabled direct navigation from exception summaries to the affected traces for faster root-cause analysis.",
          ],
        },
      ],
    },
  ];

  const notes = [
    "ServiceNow Integration: monitoring alerts can now automatically create ServiceNow tickets as soon as an issue is detected.",
    ".NET Agent Enhancements: a dedicated .NET 4.5 Agent, correct handling of UI-generated dynamic classes, and reduced noise via skipped resource calls in the .NET Core Agent.",
    "Dashboard & Visualization Enhancements: new Meter Gauge, Donut, Table View, and Progress Bar visualizations, plus per-metric title, background color, and icon configuration.",
    "Java Agent – Exception Tracking: exception class names from stack traces are now collected as searchable tags.",
    "Licensing Module: support for the ApMoSys Licensing Portal (ALP), with backward compatibility for the legacy licensing module.",
    "Enhanced MSSQL Monitoring: new metrics, dedicated dashboard visualizations, and alert configuration support for MSSQL environments.",
    "JPQL Migration: Alert, Mail, and Metric Configuration repositories migrated from native SQL to JPQL for improved Oracle compatibility and portability.",
    "Configurable Alert Email Templates: customizable subjects and bodies, dynamic placeholders, unique Problem IDs, HTML/plain-text support, and template validation with preview.",
    "Exception Analysis Module: new backend APIs and Angular UI for exception aggregation, trend analysis, and direct navigation to affected traces.",
  ];

  return (
    <div>
      <main className="transition-opacity duration-300">
        <div className="mx-auto">
          <section className="relative scroll-mt-24" id="release-details">
            <div>
              <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-orange-200 bg-orange-50 px-3 py-1 text-xs font-semibold uppercase tracking-[0.22em] text-orange-700 dark:border-orange-500/20 dark:bg-orange-500/10 dark:text-orange-300">
                <span className="h-2 w-2 rounded-full bg-orange-500" />
                Release Notes 2026.08
              </div>

              <div className="flex items-center justify-between gap-4">
                <h1 className="text-3xl font-black tracking-tight sm:text-4xl">
                  <span className="bg-gradient-to-r from-orange-500 via-red-500 to-rose-600 bg-clip-text text-transparent">
                    Netraa APM Release Notes
                  </span>
                </h1>
              </div>

              <p className="mt-4 text-base leading-7 text-slate-600 sm:text-lg dark:text-slate-300">
                Netraa APM – Release Notes
              </p>
            </div>
          </section>

          <section className="scroll-mt-24 px-0 py-4" id="intro">
            <div className="rounded-3xl border border-orange-200/70 bg-gradient-to-br from-orange-50 via-white to-white p-6 shadow-sm dark:border-orange-500/15 dark:from-orange-500/10 dark:via-slate-950/30 dark:to-slate-950/30">
              <div className="mb-4 flex items-center gap-3">
                <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-gradient-to-br from-orange-500 to-red-500 text-white shadow-lg shadow-orange-500/25">
                  ✦
                </div>
                <div>
                  <h2 className="text-2xl font-bold tracking-tight text-slate-900 dark:text-white">
                    Introduction
                  </h2>
                  <p className="text-sm text-slate-500 dark:text-slate-400">
                    What this release brings to the platform.
                  </p>
                </div>
              </div>

              <p className="text-sm leading-7 text-slate-600 dark:text-slate-300 sm:text-base">
                This release strengthens Netraa APM across nine key areas,
                spanning ServiceNow integration, .NET agent coverage,
                dashboard and visualization options, Java exception
                tracking, licensing, MSSQL monitoring, database portability,
                alert email templates, and exception analysis. Highlights
                include automated ServiceNow ticket creation from alerts, a
                dedicated .NET 4.5 Agent with dynamic class handling, new
                Meter Gauge, Donut, Table View, and Progress Bar
                visualizations, searchable exception tags for Java
                applications, licensing through the ApMoSys Licensing
                Portal (ALP), deeper MSSQL metrics and alerting, a JPQL
                migration for improved Oracle compatibility, fully
                customizable alert email templates, and a new Exception
                Analysis module.
              </p>

              <div className="mt-5 grid gap-3 sm:grid-cols-2 xl:grid-cols-4">
                {releasePills.map((item) => (
                  <div
                    key={item}
                    className="rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm font-medium text-slate-700 shadow-sm dark:border-white/10 dark:bg-slate-900/50 dark:text-slate-200"
                  >
                    {item}
                  </div>
                ))}
              </div>
            </div>
          </section>

          <section className="mt-10 w-full scroll-mt-24" id="analytics">
            <div className="mx-auto">
              <h4 className="mb-4 text-xl font-bold text-slate-900 dark:text-white">
                Release Analytics
              </h4>

              <div
                className="
      glass-card
      rounded-2xl
      border border-slate-200 dark:border-white/10
      bg-white/90 p-5 backdrop-blur-xl
      transition-all duration-500
      hover:-translate-y-1 hover:shadow-2xl
      dark:bg-white/5
      sm:p-6
    "
              >
                <div className="mb-6 grid grid-cols-2 gap-3 sm:grid-cols-4">
                  {releaseMetrics.map((item, i) => (
                    <div
                      key={i}
                      className="
              rounded-xl
              border border-slate-200 bg-white p-3
              shadow-sm
              transition-all duration-300
              hover:-translate-y-1 hover:scale-[1.02] hover:shadow-md
              dark:border-white/10 dark:bg-white/5
            "
                    >
                      <div className="mb-1 text-[11px] text-slate-500 dark:text-slate-400">
                        {item.label}
                      </div>

                      <div
                        className="
              text-lg font-bold text-orange-600
              dark:bg-gradient-to-r dark:from-orange-500 dark:to-rose-600
              dark:bg-clip-text dark:text-transparent
            "
                      >
                        {item.value}
                      </div>
                    </div>
                  ))}
                </div>

                <div className="space-y-4">
                  <div>
                    <div className="mb-1 flex justify-between text-sm text-slate-700 dark:text-slate-300">
                      <span>Deployment Readiness</span>
                      <span className="font-semibold text-orange-500">98%</span>
                    </div>

                    <div className="h-2 w-full overflow-hidden rounded-full bg-slate-200 dark:bg-slate-700">
                      <div
                        className="
              h-full w-[98%]
              bg-gradient-to-r from-orange-500 to-rose-600
              shadow-[0_0_8px_rgba(255,120,120,0.4)]
              transition-all duration-700
            "
                      />
                    </div>
                  </div>

                  <div>
                    <div className="mb-1 flex justify-between text-sm text-slate-700 dark:text-slate-300">
                      <span>Health Meter</span>
                      <span className="font-semibold text-rose-500">Optimal</span>
                    </div>

                    <div className="h-2 w-full overflow-hidden rounded-full bg-slate-200 dark:bg-slate-700">
                      <div
                        className="
              h-full w-full
              bg-gradient-to-r from-orange-500 to-rose-600
              shadow-[0_0_8px_rgba(255,120,120,0.4)]
              transition-all duration-700
            "
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="mb-12 mt-12" id="overview">
            <h2 className="mb-4 text-xl font-bold text-slate-900 dark:text-white">
              Release Details
            </h2>

            <div className="overflow-x-auto rounded-2xl border border-slate-200 dark:border-white/10">
              <table className="w-full text-left text-sm border-collapse">
                <thead className="bg-slate-50 dark:bg-white/5">
                  <tr>
                    <th className="px-5 py-3 text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400 border border-slate-200 dark:border-white/10">
                      Release Month
                    </th>
                    <th className="px-5 py-3 text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400 border border-slate-200 dark:border-white/10">
                      Organization
                    </th>
                    <th className="px-5 py-3 text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400 border border-slate-200 dark:border-white/10">
                      Prepared By
                    </th>
                  </tr>
                </thead>

                <tbody className="divide-y divide-slate-200 dark:divide-white/10">
                  <tr className="bg-white dark:bg-transparent">
                    <td className="px-5 py-4 font-medium text-orange-600 dark:text-orange-400 border border-slate-200 dark:border-white/10">
                      August 2026
                    </td>
                    <td className="px-5 py-4 text-slate-700 dark:text-slate-300 border border-slate-200 dark:border-white/10">
                      ApMoSys Products Pvt. Ltd.
                    </td>
                    <td className="px-5 py-4 text-slate-700 dark:text-slate-300 border border-slate-200 dark:border-white/10">
                      Netraa APM Product Team
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section className="scroll-mt-24" id="enhancements">
            <div className="mb-6 flex items-end justify-between gap-4">
              <div>
                <h2 className="text-2xl font-bold tracking-tight text-slate-900 dark:text-white">
                  Major Feature Enhancements
                </h2>
                <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
                  Exact feature list from the release notes.
                </p>
              </div>
            </div>

            <div className="space-y-4">
              {majorFeatureEnhancements.map((section) => (
                <article
                  key={section.title}
                  className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm dark:border-white/10 dark:bg-slate-900/60"
                >
                  <div className="flex items-start gap-4">
                    <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-orange-500 to-red-500 text-sm font-bold text-white shadow-md shadow-orange-500/20">
                      {section.number}
                    </div>

                    <div className="min-w-0 w-full">
                      <h3 className="text-base font-bold text-slate-900 dark:text-white">
                        {section.title}
                      </h3>

                      <div className="mt-3 space-y-4">
                        {section.subsections.map((sub) => (
                          <div key={sub.title}>
                            <h4 className="text-sm font-semibold text-orange-600 dark:text-orange-400">
                              {sub.title}
                            </h4>
                            <ul className="mt-2 space-y-2">
                              {sub.items.map((point) => (
                                <li
                                  key={point}
                                  className="flex gap-3 text-sm leading-6 text-slate-600 dark:text-slate-300"
                                >
                                  <span className="mt-2 h-2 w-2 shrink-0 rounded-full bg-orange-500" />
                                  <span>{point}</span>
                                </li>
                              ))}
                            </ul>
                          </div>
                        ))}

                        {/* Point No. 1 - 2 Images */}
                        {section.title === "ServiceNow Integration" && (
                          <div className="mt-4 space-y-4">
                            <img
                              src={serviceNowImg1}
                              alt="ServiceNow Integration"
                              className="mt-4 w-full border border-slate-200 shadow-md dark:border-white/10 cursor-zoom-in transition-all duration-300 hover:shadow-xl hover:scale-[1.01]"
                              onClick={() => setZoomImage(serviceNowImg1)}
                            />

                            <img
                              src={serviceNowImg2}
                              alt="ServiceNow Ticket Creation"
                              className="mt-4 w-full border border-slate-200 shadow-md dark:border-white/10 cursor-zoom-in transition-all duration-300 hover:shadow-xl hover:scale-[1.01]"
                              onClick={() => setZoomImage(serviceNowImg2)}
                            />
                          </div>
                        )}

                        {/* Point No. 3 - 1 Image */}
                        {section.title === "Dashboard & Visualization Enhancements" && (
                          <div className="mt-4">
                            <img
                              src={dashboardImg}
                              alt="Dashboard Visualization"
                              className="mt-4 w-full border border-slate-200 shadow-md dark:border-white/10 cursor-zoom-in transition-all duration-300 hover:shadow-xl hover:scale-[1.01]"
                              onClick={() => setZoomImage(dashboardImg)}
                            />
                          </div>
                        )}

                        {/* Point No. 8 - 1 Image */}
                        {section.title === "Configurable Alert Email Templates" && (
                          <div className="mt-4">
                            <img
                              src={emailTemplateImg}
                              alt="Configurable Alert Email Templates"
                              className="mt-4 w-full border border-slate-200 shadow-md dark:border-white/10 cursor-zoom-in transition-all duration-300 hover:shadow-xl hover:scale-[1.01]"
                              onClick={() => setZoomImage(emailTemplateImg)}
                            />
                          </div>
                        )}

                        {/* Point No. 9 - 1 Image */}
                        {section.title === "Exception Analysis Module" && (
                          <div className="mt-4">
                            <img
                              src={exceptionAnalysisImg}
                              alt="Exception Analysis Module"
                              className="mt-4 w-full border border-slate-200 shadow-md dark:border-white/10 cursor-zoom-in transition-all duration-300 hover:shadow-xl hover:scale-[1.01]"
                              onClick={() => setZoomImage(exceptionAnalysisImg)}
                            />
                          </div>
                        )}
                      </div>

                      {section.title === "Enhanced MSSQL Monitoring" && (
                        <div className="mt-4">
                          <h4 className="text-sm font-semibold text-orange-600 dark:text-orange-400">
                            Available MSSQL Metrics
                          </h4>
                          <div className="mt-2 max-h-96 overflow-y-auto overflow-x-auto rounded-xl border border-slate-200 dark:border-white/10">
                            <table className="w-full text-left text-xs border-collapse">
                              <thead className="sticky top-0 bg-slate-50 dark:bg-slate-900">
                                <tr>
                                  <th className="px-3 py-2 font-semibold text-slate-500 dark:text-slate-400 border border-slate-200 dark:border-white/10">
                                    Metric
                                  </th>
                                  <th className="px-3 py-2 font-semibold text-slate-500 dark:text-slate-400 border border-slate-200 dark:border-white/10">
                                    Description
                                  </th>
                                  <th className="px-3 py-2 font-semibold text-slate-500 dark:text-slate-400 border border-slate-200 dark:border-white/10">
                                    Unit
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="divide-y divide-slate-200 dark:divide-white/10">
                                {mssqlMetrics.map((m) => (
                                  <tr key={m.name} className="bg-white dark:bg-transparent">
                                    <td className="px-3 py-2 font-mono text-orange-600 dark:text-orange-400 border border-slate-200 dark:border-white/10 whitespace-nowrap">
                                      {m.name}
                                    </td>
                                    <td className="px-3 py-2 text-slate-600 dark:text-slate-300 border border-slate-200 dark:border-white/10">
                                      {m.desc}
                                    </td>
                                    <td className="px-3 py-2 text-slate-600 dark:text-slate-300 border border-slate-200 dark:border-white/10 whitespace-nowrap">
                                      {m.unit}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </section>

          <section className="py-8 scroll-mt-24" id="notes">
            <div className="grid gap-8 lg:grid-cols-2">
              <div>
                <h2 className="text-2xl font-bold text-slate-900 dark:text-white">
                  Additional Notes
                </h2>
                <p className="mt-2 text-sm text-slate-500 dark:text-slate-400">
                  Extra content kept in the layout.
                </p>

                <ul className="mt-6 space-y-4">
                  {notes.map((item) => (
                    <li key={item} className="flex items-start gap-3">
                      <span className="mt-1 h-2 w-2 rounded-full bg-orange-500" />
                      <span className="text-sm leading-6 text-slate-600 dark:text-slate-300">
                        {item}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="rounded-2xl bg-gradient-to-br from-orange-500 to-red-600 p-6 text-white shadow-lg">
                <h3 className="text-xl font-bold">Release Summary</h3>

                <p className="mt-3 text-sm leading-6 text-white/90">
                  This release strengthens Netraa APM across nine key areas,
                  delivering ServiceNow integration, expanded .NET agent
                  coverage, richer dashboard visualizations, Java exception
                  tracking, ApMoSys Licensing Portal support, deeper MSSQL
                  monitoring, JPQL-based database portability, configurable
                  alert email templates, and a new Exception Analysis
                  module.
                </p>

                <div className="mt-5 text-sm font-semibold">
                  Status: Major enhancements and platform improvements
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>

      {/* Zoom modal */}
      {zoomImage && (
        <div
          className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4 backdrop-blur-sm"
          onClick={() => setZoomImage(null)}
        >
          <img
            src={zoomImage}
            alt="Zoomed Preview"
            className="max-w-[95vw] max-h-[90vh] object-contain transition-all duration-300"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </div>
  );
}